import * as React from "react";

/* global window */

const useResizeCount = () => {
  const [resizeCount, setResizeCount] = React.useState(0);

  React.useEffect(() => {
    const handleResize = () => {
      setResizeCount((prev) => prev + 1);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return resizeCount;
};

export default useResizeCount;
